(function ($) {
	if (typeof CountUp === 'undefined') {
		return;
	}

	let $counters = null;

	function setDataForStats() {
		const $values = $('.count-up');

		if (!$values.length) {
			return;
		}

		$values.each(wrapStatNumbers);

		const $wrappedStats = $('.stat-value-countup');

		if (!$wrappedStats.length) {
			return;
		}

		$wrappedStats.each(setDataStat);
	}

	function setDataStat() {
		const $this = $(this);
		const value = $this.html().replace(/,/gi, '');

		$this.css({ minWidth: $this.width() + 10 + 'px', textAlign: 'right' });

		$this.html(0);
		$this.attr('data-count-start', 0);
		$this.attr('data-count-end', value);
	}

	function wrapStatNumbers() {
		const $this = $(this);

		const newHTML = $this
			.text()
			.replace(/[\d,\,,\.]+/g, '<span class="stat-value-countup">$&</span>');

		$this.html(newHTML);
	}

	let previousPageY = -1;

	function watchIfCountersOnScreen() {
		if (previousPageY === window.pageYOffset) {
			window.requestAnimationFrame(watchIfCountersOnScreen);
			return;
		}

		previousPageY = window.pageYOffset;

		let $this = null;
		let shouldUpdateCounters = false;

		$counters.each(function () {
			$this = $(this);

			if (isOnScreen(this) && !$this.hasClass('counted')) {
				$this.addClass('counted');
				shouldUpdateCounters = true;
				runCountUp($this);
			}
		});

		if (shouldUpdateCounters) {
			// set them again!
			setAllCounters();
		}

		if ($counters.length) {
			// if we still have counters... keep on watching them!
			window.requestAnimationFrame(watchIfCountersOnScreen);
		}
	}

	const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);

	function isOnScreen(elm, threshold = 200) {
		const rect = elm.getBoundingClientRect();
		const above = rect.top + threshold < windowHeight;

		return above;
	}

	function runCountUp($this) {
		const end = $this.data('count-end');
		const start = $this.data('count-start') || parseFloat($this.text());

		$this.data('count-start', end);

		let decimals = 0;
		const hasDecimalPlaces = end % 1;
		if (hasDecimalPlaces) {
			decimals = end.toString().split('.')[1].length || 0;
		}

		if (start !== end) {
			const duration = 600;
			const countUp = new CountUp($this[0], start, end, decimals, duration / 1000, {
				useEasing: true,
			});
			countUp.start();

			const extraDelay = 800;

			$this.data('statHighlights').each(function (index) {
				setTimeout(() => {
					$(this).removeClass('force-unhighlight');
				}, duration + extraDelay * index);
			});
		}
	}

	function setAllCounters() {
		$counters = $('[data-count-end]:not(".counted")');

		$counters.each(function () {
			const $this = $(this);

			$this.data(
				'statHighlights',
				$this.closest('.wp-block-group').find('.guidance-report-statistic strong'),
			);

			if ($this.data('statHighlights').length) {
				$this.data('statHighlights').addClass('force-unhighlight');
			}
		});
	}

	setDataForStats();
	setAllCounters();
	setTimeout(watchIfCountersOnScreen, 1000);

	window.runCountUp = runCountUp;
})(jQuery);
